/** @jsx jsx */
import { jsx, keyframes, css } from '@emotion/react';
export const combine = (...classNames) => {
    return classNames
        .flat()
        .filter((v) => v)
        .join(' ');
};
export const noOfLines = css `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--chakra-line-clamp);
`;
const bgFade = keyframes({
    from: {
        background: '#EDF2F7',
    },
    to: {
        background: '#A0AEC0',
    },
});
export const Skeleton = (props) => {
    return (jsx("div", { css: {
            height: '100px',
            animation: `0.8s linear infinite alternate ${bgFade}`,
        }, ...props, className: combine('t-announcement_skeleton', props.className) }));
};
export const Flex = (props) => {
    return (jsx("div", { css: {
            display: 'flex',
        }, ...props, className: combine('t-announcement_flex', props.className) }));
};
export const Link = (props) => {
    return (jsx("a", { css: {
            color: '#C42F74',
            fontWeight: '800',
            fontSize: '14px',
            lineHeight: '18px',
            textDecoration: 'none',
        }, href: "javascript:void(0);", ...props, className: combine('t-announcement_link', props.className) }));
};
